module.exports = __webpack_public_path__ + "img/diplome-etat-controle.ca7b9da.png";